export default "__VITE_ASSET__Nc6Uksfl__"